/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmrClusterVolumeSpecification { 
    /**
     * The volume type. Volume types supported are gp2, io1, standard
     */
    volumeType?: string;
    /**
     * The number of I/O operations per second (IOPS) that the volume supports
     */
    iops?: number;
    /**
     * The volume size, in gibibytes (GiB). This can be a number from 1 - 1024. If the volume type is EBS-optimized, the minimum value                   is 10                
     */
    sizeInGB?: number;
    /**
     * The throughput, in mebibyte per second (MiB/s). This optional parameter can be a number from 125 - 1000 and is valid only for                   gp3 volumes                
     */
    throughput?: number;
}
